import React, { Fragment, useEffect, useState } from 'react';
import {
    Grid,
    TextField,
    Button,
    Select,
    MenuItem,
    Fade,
    Typography,
    ClickAwayListener,
    Tooltip,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useStyle } from './PrequalStyle.js';
import { useApolloClient } from '@apollo/client';
import { getAreaCodes } from './EirPrequalIntegration.js';
import { getContext } from './EirPrequalUtil';
import { useLocalStorage } from './EirPrequalPersistance';
import { TOOLTIP_TEXT_FIRST_PARA, TOOLTIP_TEXT_SECOND_PARA, VALIDATION_TEXT, USE_PHONENUMBER_TEXT, checkAvailabilityText, PHONENUMBER_TEXTFIELD_TOOLTIPICON_IMAGE } from './Constants'
export default function EirPrequalPhoneNumberForm(props) {
    const classes = useStyle();
    const [areaCode, setAreaCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [prequalPhoneNumber, setPrequalPhoneNumber] = useState({ areaCode: '', number: '' });
    const [disableButton, setDisableButton] = useState(true);
    const [toolTipOpen, setToolTipOpen] = useState(false);
    const [fontColor, setFontColor] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [areaCodes, setAreaCodes] = useState([]);
    const {getLocalStorage, setLocalStorage} = useLocalStorage();


    const context = getContext();
    const eirPrequalFlag = 'phone';

    const graphql = useApolloClient();
    let toolTipTimeout = null;

    useEffect(() => {
        if (!fontColor) setFontColor(props.prop.resources.textFontColor);
        
        // if (context === 'broadband') {
        //     window.history.pushState({}, '', window.location.origin + '/broadband');
        //     setLocalStorage('currentContext', 'broadband');
        // }
        // else if (context === 'tv') {
        //     window.history.pushState({}, '', window.location.origin + '/tv');
        //     setLocalStorage('currentContext', 'tv');
        // }
        // else {
        //     let currentContext = window.location.pathname;
        //     currentContext = currentContext.slice(1, -1);
        //     // if(!currentContext.includes('broadband') && !currentContext.includes('tv') )
        //     // {
        //         if((currentContext.split('/').length-1) === 0)
        //         {
        //             setLocalStorage('currentContext',currentContext);
        //         }

        //         let cont = getLocalStorage('currentContext');
        //         window.history.pushState({}, '', window.location.origin + `/${cont}`);
        //     // }
        // }
    }, []);
    useEffect(() => {
        if (`${areaCode}`.length !== 0 && `${phoneNumber}`.length > 4)
            setDisableButton(false);
        else
            setDisableButton(true);

        setPrequalPhoneNumber({
            areaCode: areaCode,
            number: parseInt(phoneNumber),
        });

        if (toolTipTimeout) {
            clearTimeout(toolTipTimeout);
        }
    }, [areaCode, phoneNumber]);

    useEffect(() => {
        (
            async function getAreaCode() {
                try {
                    let data = await getAreaCodes(graphql);
                    setAreaCodes(data.areaCodes)
                }
                catch (err) {
                    setAreaCodes([]);
                }
            }
        )();
    }, []);
    useEffect(()=>{
        //getting the context from the url
        let currentContext = window.location.pathname.slice(1);
            //when first time pages other than broadband or tv loads
            if(!getLocalStorage('currentContext'))
            {
                setLocalStorage('currentContext',currentContext);
            }
            
            else if(window.location.pathname.includes(getLocalStorage('currentContext')) === false) 
                setLocalStorage('currentContext',currentContext);   
            
            //when page comed back from /results it will get the context from localstorage and set the virtual url
            if(getLocalStorage('currentContext'))
            {
                let cont = getLocalStorage('currentContext');
                window.history.pushState({}, '', window.location.origin + `/${cont}`);
            }
},[]);

    const phoneNumberChangeHandler = (e) => {
        e.preventDefault();
        if (isNaN(e.target.value) === true) {
            setPhoneNumberError(true);
            setDisableButton(true);
        }
        if (isNaN(e.target.value) === false ) {
            if((e.target.value).length > 4)
            {
                if(`${areaCode}`.length !== 0)
                {
                    setPhoneNumberError(false);
                    setPhoneNumber(e.target.value);
                    setDisableButton(false);
                }
                else{
                    setPhoneNumberError(false);
                    setPhoneNumber(e.target.value);
                }

            }
            else{
                setPhoneNumber(e.target.value);
                setPhoneNumberError(false);
                setDisableButton(true);
            }
        }
        
    };
    const handleTooltipOnOpen = () => {
        toolTipTimeout = setTimeout(() => { setToolTipOpen(false) }, 1500);
    }

    //check availability submit function
    const checkAvailability = () => {
        props.prop.submitHandler(graphql, prequalPhoneNumber, eirPrequalFlag, 'Phone');
    };
    return (
        <Fragment>
            <Grid container className={classes.PhoneInputContainer}>
                <div className={classes.NumberAndMessageContainer}>
                    <div className={classes.CodeAndNumberContainer}>
                        <Select
                            className={classes.PrequalAreaCode + ' ' + (!areaCode?classes.AreaCodeNullColor:classes.AreaCodeFilledColor)}                          
                            IconComponent={(props) => <KeyboardArrowDownIcon {...props} />}
                            disableUnderline={true}
                            labelId='prequal-area-code-label'
                            id='prequal-area-code'
                            label='Prefix'
                            value={areaCode}
                            error={phoneNumberError}
                            displayEmpty
                            onChange={e => { setAreaCode(e.target.value); }}
                            renderValue={(selected) => {
                                if (selected.length === 0)
                                    return 'Prefix';
                                return selected;
                            }}
                        >
                            {areaCodes.map((ele) => {
                                return <MenuItem key={ele.AREA_CODE} value={ele.AREA_CODE}>{ele.AREA_CODE}</MenuItem>
                            })}
                        </Select>
                        <TextField
                            className={classes.PrequalPhoneNumber}
                            id='prequal-phone-number'
                            placeholder='Phone number' 
                            margin='normal' 
                            variant='outlined'
                            error={phoneNumberError}
                            inputProps={{ maxLength: 7 }}
                            InputProps={{
                                classes: { input: classes.TextFieldPlaceholder },
                                endAdornment: (
                                    <ClickAwayListener onClickAway={() => setToolTipOpen(false)}>
                                        <Tooltip
                                            title={<div><span className={classes.toolTipText}>{TOOLTIP_TEXT_FIRST_PARA}</span><br /><br />
                                                <span className={classes.toolTipText}>{TOOLTIP_TEXT_SECOND_PARA}</span></div>}
                                            classes={{ tooltip: classes.PhoneNumberTextFieldTooltip }}
                                            TransitionComponent={Fade}
                                            open={toolTipOpen}
                                            placement='right'
                                            arrow>
                                            <img
                                                src={PHONENUMBER_TEXTFIELD_TOOLTIPICON_IMAGE}
                                                className={classes.PhoneNumberTextFieldIconImage}
                                                onMouseEnter={() => { setToolTipOpen(true) }}
                                                onClick={() => { setToolTipOpen(true) }}
                                                onMouseOut={() => { handleTooltipOnOpen() }}
                                            />
                                        </Tooltip>
                                    </ClickAwayListener>
                                ),
                            }}
                            onChange={(e)=>phoneNumberChangeHandler(e)}
                        />
                    </div>
                    {(phoneNumberError) ? <div className={classes.UseEircode}>
                        <Typography className={classes.PhoneValidity}
                            style={{ color: fontColor }}>{VALIDATION_TEXT.phoneNumberValidation}</Typography>
                    </div> : <div className={classes.UseEircode}>
                        <Typography className={classes.AddressNotFoundText} style={{ color: fontColor }}>{USE_PHONENUMBER_TEXT.text}</Typography>
                        <Typography
                            className={classes.AddressNotFoundLink}
                            style={{ color: fontColor }}
                            onClick={() => { props.makeEircodeVisible() }}>{USE_PHONENUMBER_TEXT.urlText}</Typography>
                    </div>}
                </div>
                <Button
                    className={classes.PrequalPhoneNumberSubmitButton}
                    disableRipple={true}
                    id='check_via_phoneNumber'
                    variant='contained'
                    size='large'
                    color='primary'
                    type='button'
                    disabled={disableButton}
                    onClick={() => { checkAvailability(); }
                    }>
                    {checkAvailabilityText}
                </Button>
            </Grid>
        </Fragment>
    );
}
